import { api } from './api-client';
import type { DauData, FilterGroup } from '@/types';

type RangeParams = {
  projectId: string;
  interval: string;
  startDate: Date;
  endDate: Date;
  filterGroups?: FilterGroup[];
};

export type CompanyActivity = { perDay: DauData['perDay']; total: number };

export type EventCompany = {
  id: string;
  name: string | null;
  domain: string | null;
  events: number;
  users: number;
};

export const CompanyActivityService = {
  getActivity: async (params: RangeParams) => {
    const { data } = await api.post<{ data: CompanyActivity }>(
      `/analytics/companies`,
      params,
    );
    return data;
  },
  getForEvent: async (params: RangeParams & { eventName: string }) => {
    const { data } = await api.post<{ data: EventCompany[] }>(
      `/analytics/companies/by-event`,
      params,
    );
    return data;
  },
};
